module.exports = __webpack_public_path__ + "static/media/gorge.6aeabcab.jpeg";